import { get } from 'lodash';
import { connect } from 'react-redux';

import { actions } from 'Data/actions';
import { EMPTY_OBJ } from 'Services/constants/empty';
import Switcher from './component';

const mapStateToProps = (state) => ({
  consultGuid: get(state, ['Location', 'payload', 'consult_guid']),
  attendeeId: get(state, ['Location', 'payload', 'attendee_guid']),
  pageType: get(state, ['Location', 'type']),
  queryString: get(state, ['Location', 'query'], EMPTY_OBJ),
});

const mapDispatchToProps = (dispatch) => ({
  modalCloseAll: () => dispatch(actions.modalCloseAll()),
  meetingPutPatientCode: (code, dataTransferFailed) => dispatch(actions
    .meetingPutPatientCode(code, dataTransferFailed)),
  recordUnsupportedBrowser: (meetingId, attendeeId, browserDetails) => dispatch(actions
    .recordUnsupportedBrowser(meetingId, attendeeId, browserDetails)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Switcher);
